export default __webpack_public_path__ + "static/Group 3-b7026315d234b0d69b9ab0f2807b1aa4.png";